export default "__VITE_ASSET__DekIitFH__"